import zappy from "@zappy-ride/library.react.components";
import { FormStatsVehicle } from "./FormStatsVehicle";

export * from "./FormStatsVehicle";

zappy.FactoryInstance.registerComponent(FormStatsVehicle);
